import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "InfoIcon",
  xmlns: "http://www.w3.org/2000/svg",
  width: "13",
  height: "13",
  viewBox: "0 0 13 13",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M6.41667 1.16667C3.51717 1.16667 1.16667 3.51717 1.16667 6.41667C1.16667 9.31616 3.51717 11.6667 6.41667 11.6667C9.31616 11.6667 11.6667 9.31616 11.6667 6.41667C11.6667 3.51717 9.31616 1.16667 6.41667 1.16667ZM0 6.41667C0 2.87284 2.87284 0 6.41667 0C9.96049 0 12.8333 2.87284 12.8333 6.41667C12.8333 9.96049 9.96049 12.8333 6.41667 12.8333C2.87284 12.8333 0 9.96049 0 6.41667ZM6.41667 3.5C6.73883 3.5 7 3.76117 7 4.08333V6.41667C7 6.73883 6.73883 7 6.41667 7C6.0945 7 5.83333 6.73883 5.83333 6.41667V4.08333C5.83333 3.76117 6.0945 3.5 6.41667 3.5ZM5.83333 8.75C5.83333 8.42783 6.0945 8.16667 6.41667 8.16667H6.4225C6.74467 8.16667 7.00583 8.42783 7.00583 8.75C7.00583 9.07217 6.74467 9.33333 6.4225 9.33333H6.41667C6.0945 9.33333 5.83333 9.07217 5.83333 8.75Z",
  fill: "#858D9C"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render };